enum AddressType {
  STARTING = "STARTING",
  MAILING = "MAILING",
}

export default AddressType;
